import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Button from 'src/components/Button/Button';
import { RootState } from 'src/configs/store';
import AllowPayout from './AllowPayout';

interface ConfirmationModalProps {
  close: () => void
}

function ConfirmationModal({ close }: ConfirmationModalProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const isPayout= (location.hash).includes('payout');
  const query = new URLSearchParams(location.hash);
  const [showModal, setShowModal] = useState('');

  const checkBalacePayoutWithoutMoney = useSelector((state: RootState) => {
    if (state.peripherals.payoutUnderBalance === false){
      return 0;
    } else if (state.peripherals.payoutUnderBalance === true && state.peripherals.confirmPayoutUnderBalance === true){
      return 1;
    }
    return 2;
  });
  const closingBalance = useSelector((state: RootState) => state.peripherals.closingBalance);

  const code = query.get('code');
  const pin = query.get('pin');
  const value = query.get('value');

  const getTotals = async () => {
    await dispatch.peripherals.getOverview();
  };

  useEffect(() => {
    getTotals();
  }, []);


  const checkPayoutBalance = async () => {
    if (checkBalacePayoutWithoutMoney === 2){
      await dispatch.peripherals.payoutTicket({ ticket: code, pin });
    } else {
      await getTotals();
      if (+closingBalance >= +value){
        await dispatch.peripherals.payoutTicket({ ticket: code, pin });
        setShowModal(null);
        close();
      } else if (+closingBalance < +value && checkBalacePayoutWithoutMoney === 0){
        setShowModal('dontAllow');
      } else {
        setShowModal('allow');
      }
    }
  };

  const onPayoutSubmit = async () => {
    await dispatch.peripherals.payoutTicket({ ticket: code, pin });
    setShowModal(null);
    close();
  };

  const handleConfirm = async () => {
    if (!isPayout){
      await dispatch.peripherals.cancelTicket({ ticket: code, pin });
      close();
    } else {
      checkPayoutBalance();
    }
  };

  const checkPressedKey = (e) => {
    if (e.key === 'Enter'){
      handleConfirm();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', checkPressedKey);
    return () => {
      window.removeEventListener('keydown', checkPressedKey);
    };
  }, []);

  const checkPayoutMessage = () => {
    if (value && +value > 0){
      return t('ticketDetails.confirmPayoutValue', { code, value });
    }
    return `${ t('ticketDetails.confirmPayout') }: ${ code }`;
  };

  return (
    <div className="cancel-ticket__modal">
      <h3 className="cancel-ticket__title">{ !isPayout ? `${ t('ticketDetails.cancelTicket') }`:  `${ t('ticketDetails.payoutTicket') }` }</h3>
      <h3 className="cancel-ticket__subtitle">{
        !isPayout ?
          `${ t('ticketDetails.confirmCancelation') }: ${ code }` :
          checkPayoutMessage()
      }</h3>
      <div className="cancel-ticket__buttons">
        <Button
          type="button"
          text={ t('ticketDetails.confirm') }
          className="btn btn--cta modal-submit"
          onClick={ handleConfirm }
        />
        <Button
          type="button"
          text={ t('ticketDetails.close') }
          className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
          onClick={ close }
        />
      </div>
      {
        showModal &&
            <AllowPayout onClose={ () => setShowModal(null) } onSubmit={ onPayoutSubmit } type={ showModal } />
      }
    </div>
  );
}

export default ConfirmationModal;
